import * as api from "Api";
import * as actions from "Actions";
import { getUpdateBudgetByRole, updateBudgetByRole } from "../../api";
import { getBudgetByRole } from "../actions";

export const fetchBudgetTree = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const {
      year,
      client,
      clientGroup,
      collaborator,
      searchWord
    } = getState().budget.filter;
    dispatch(
      actions.fetchBudgetTree(
        api
          .getBudgetTree(
            currentOrganization.id,
            client.selected,
            clientGroup.selected,
            collaborator.selected,
            collaborator.role,
            year.selected,
            searchWord.searchWord
          )
          .then(res => {
            return res.data.data;
          })
      )
    );
  };
};

export const fetchBudgetCollaborator = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const { year } = getState().clients.list;

    return dispatch(
      actions.getCollaboratorBudget(
        api.getCollaboratorBudget(currentOrganization.id, year).then(res => {
          return res.data.data;
        })
      )
    );
  };
};

export const fetchQuickBudget = () => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  const clientId = getState().budget.quick.client.id;
  const year = getState().budget.quick.year;
  return dispatch(
    actions.fetchQuickBudgetClient(
      api
        .getQuickBudgetClient(currentOrganization.id, clientId, year, null)
        .then(res => {
          return res.data.data;
        })
    )
  );
};

export const saveQuickBudget = (budget, clientId, year, status) => (
  dispatch,
  getState
) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.saveQuickBudgetClient(
      api.saveQuickBudgetClient({
        organization: currentOrganization.id,
        budget,
        clientId,
        year,
        status
      })
    )
  );
};

export const fetchBudget = () => (dispatch, getState) => {
  let {
    auth: { currentOrganization },
    budget: {
      setting: { client }
    },
    clients: {
      list: { year }
    }
  } = getState();
  const clientId = client.id;
  year = year ? year : new Date().getFullYear();
  return dispatch(
    actions.fetchBudgetClient(
      api.getBudgetClient(currentOrganization.id, clientId, year).then(res => {
        return res.data.data;
      })
    )
  );
};

export const updateBudgetClient = (budget, periodSetting, status) => (
  dispatch,
  getState
) => {
  let {
    auth: { currentOrganization },
    clients: {
      list: { year }
    }
  } = getState();
  return dispatch(
    actions.updateBudgetClient(
      api.updateBudgetClient({
        organization: currentOrganization.id,
        year,
        budget,
        periodSetting,
        status
      })
    )
  );
};

export const cloneAndSavedBudget = budget => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.cloneAndSavedBudget(
      api.cloneBudgetClient({
        ...budget,
        organization: currentOrganization.id
      })
    )
  );
};

export const fetchBudgetStatesCount = () => (dispatch, getState) => {
  let {
    auth: {
      currentOrganization: { id }
    }
  } = getState();

  const {
    filter: { year }
  } = getState().budget.dynamicTable;

  return dispatch(
    actions.getBudgetStatesCount(api.getBudgetStatesCount(id, year))
  );
};
export const updatedBudgetByRole = year => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.getBudgetByRole(
      api.updateBudgetByRole(currentOrganization.id, year).then(res => {
        return res.data.data;
      })
    )
  );
};

export const getUpdatedBudget = year => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.updateBudgetByRole(
      api.getUpdatedBudget(currentOrganization.id, year).then(res => {
        return res.data.data;
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/budget.js